export default __webpack_public_path__ + "static/media/instructions-star.16251804.png";